import React from 'react';

const designSystem = {
  colors: {
    primary: 'rgb(5, 94, 253)',
    background: 'rgb(255, 255, 255)',
    lightBackground: 'rgb(249, 249, 251)',
    text: 'rgb(34, 35, 36)',
    textSecondary: 'rgb(107, 114, 126)',
    border: 'rgb(229, 231, 235)',
    success: 'rgb(34, 197, 94)',
    warning: 'rgb(245, 158, 11)'
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    fontWeights: { medium: 500, semibold: 600, bold: 700 }
  },
  borderRadius: '4px',
  spacing: { xs: '4px', sm: '8px', md: '12px', lg: '16px', xl: '24px' }
};

const PresetButton = ({ active, onClick, children, isMobile, icon }) => (
  <button
    onClick={onClick}
    className={`w-full flex items-center gap-3 px-4 py-3 rounded transition-colors ${
      active
        ? 'text-white bg-[#3B3C42]'
        : 'text-gray-700 hover:bg-[#2A2B2F] hover:text-white'
    }`}
    style={{
      border: 'none',
      cursor: 'pointer',
      fontFamily: designSystem.typography.fontFamily,
      fontSize: isMobile ? '13px' : '14px',
      fontWeight: designSystem.typography.fontWeights.medium,
      minHeight: '44px',
      justifyContent: 'flex-start'
    }}
  >
    <i className={`fa ${icon} text-sm`} style={active ? {color: '#3395FF'} : {}}></i>
    <span className="font-medium text-sm">{children}</span>
  </button>
);

const PersonalityPresets = ({ activePreset, onPresetSelect, showCustom, onToggleCustom, isMobile }) => {
  return (
    <div style={{ marginBottom: designSystem.spacing.xl }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
        gap: designSystem.spacing.sm,
        marginBottom: designSystem.spacing.lg
      }}>
        <PresetButton 
          active={activePreset === 'efficient'}
          onClick={() => onPresetSelect('efficient')}
          isMobile={isMobile}
          icon="fa-clipboard-list"
        >
          {isMobile ? 'Efficient' : 'Efficient Receptionist'}
        </PresetButton>
        
        <PresetButton 
          active={activePreset === 'friendly'}
          onClick={() => onPresetSelect('friendly')}
          isMobile={isMobile}
          icon="fa-handshake"
        >
          {isMobile ? 'Friendly' : 'Friendly Concierge'}
        </PresetButton>
        
        <PresetButton 
          active={activePreset === 'helpful'}
          onClick={() => onPresetSelect('helpful')}
          isMobile={isMobile}
          icon="fa-bullseye"
        >
          {isMobile ? 'Helpful' : 'Helpful Assistant'}
        </PresetButton>
      </div>
      
      <PresetButton 
        active={showCustom}
        onClick={onToggleCustom}
        isMobile={isMobile}
        icon="fa-cog"
      >
        {showCustom ? 'Hide' : 'Show'} Custom Settings
      </PresetButton>
    </div>
  );
};

export default PersonalityPresets;